import {useEffect, useRef} from 'react';

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    const match = value?.isHurlyPage ? value?.initialMatch : value?.match

    ref.current = {
      ...value,
      match
    };
  });
  return ref.current;
}

export {
  usePrevious,
}
